// components/Hero.jsx
import React from "react";
import "./Hero.css";
import dashboardImage from "../image/hero-dashboard-new.png";


const Hero = () => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  const stats = [
    { value: "50+",   label: "Active Outlets" },
    { value: "2K+",   label: "Bills / Day"    },
    { value: "99.9%", label: "Uptime"         },
    { value: "24/7",  label: "Support"        },
  ];

  return (
    <section className="hero" id="hero">
      {/* Animated Background Orbs */}
      <div className="hero__orb hero__orb--1" />
      <div className="hero__orb hero__orb--2" />
      <div className="hero__orb hero__orb--3" />

      <div className="container">
        <div className="hero__grid">
          {/* Left Content */}
          <div className="hero__content">
            <div className="hero__badge">
              <span className="hero__badge-dot" />
              <span>Now with Smart Inventory & KOT</span>
            </div>

            <h1 className="hero__title">
              The <span className="gradient-text">Smartest POS</span> for Your
              Food Business
            </h1>

            <p className="hero__subtitle">
              KadaiPOS is a cloud-based point of sale system built for
              restaurants, cafes, bakeries, cloud kitchens & more. Fast billing,
              real-time analytics, and smart inventory — all in one platform.
            </p>

            <div className="hero__buttons">
              <button
                className="btn btn-primary"
                onClick={() => scrollToSection("contact")}
              >
                Start Free Trial
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M12 5l7 7-7 7" />
                </svg>
              </button>
              <button
                className="btn btn-secondary"
                onClick={() => scrollToSection("features")}
              >
                Explore Features
              </button>
            </div>

            {/* Stats */}
            <div className="hero__stats">
              {stats.map((stat, i) => (
                <div key={i} className="hero__stat">
                  <span className="hero__stat-value">{stat.value}</span>
                  <span className="hero__stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Dashboard Image */}
          <div className="hero__image-wrapper">
            <div className="hero__image-glow" />
            <img
              src={dashboardImage}
              alt="KadaiPOS Dashboard"
              className="hero__image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
